import React from 'react';
import './index.scss';
import HelpBalloon from '../HelpBalloon/HelpBalloon';
// import { Container } from './styles';

function IntelligenceCardInfo({
  blt,
  bot,
  status,
  intencoes,
  entidades,
  condicoes,
  testar,
  aprimoramento,
}) {
  const IaPlatform =
    bot && bot.ia && bot.ia.platforms.find((element) => element.isActive);

  return (
    <div
      className={
        IaPlatform && IaPlatform.platform === 'luis'
          ? 'card-info'
          : 'card-info card-info-without-luis'
      }
    >
      <p
        onClick={() => status('status')}
        className={blt === 'status' ? 'txt-info' : ' '}
      >
        <div className={blt === 'status' ? 'bullet-ia' : ' '} />
        Status
      </p>
      <p
        onClick={() => intencoes('intencoes')}
        className={blt === 'intencoes' ? 'txt-info' : ' '}
      >
        <div className={blt === 'intencoes' ? 'bullet-ia' : ' '} />
        Intenções
        <HelpBalloon
          id="intent"
          message="Definem o tema principal da frase do usuário, escolha as variações na forma de solicitar um mesmo assunto (normalmente é um verbo)."
        />
      </p>
      <p
        onClick={() => entidades('entidades')}
        className={blt === 'entidades' ? 'txt-info' : ' '}
      >
        <div className={blt === 'entidades' ? 'bullet-ia' : ' '} />
        Entidades
        <HelpBalloon
          id="entity"
          message="São variáveis das intenções. Partes do texto que completam o sentido das intenções (podem ser substantivos, adjetivos, coisas, produtos e serviços, etc)."
        />
      </p>
      <p
        onClick={() => condicoes('condicoes')}
        className={blt === 'condicoes' ? 'txt-info' : ' '}
      >
        <div className={blt === 'condicoes' ? 'bullet-ia' : ' '} />
        Condições
        <HelpBalloon
          id="condition"
          message="Defina qual o fluxo seguir para cada retorno de confiança."
        />
      </p>
      <p
        onClick={() => testar()}
        className={blt === 'testar' ? 'txt-info' : ' '}
      >
        <div className={blt === 'testar' ? 'bullet-ia' : ' '} />
        Testar
        <HelpBalloon
          id="test"
          message="Testar uma frase para saber qual intenção a IA irá acionar."
        />
      </p>
      <p
        onClick={() => aprimoramento('aprimoramento')}
        className={blt === 'aprimoramento' ? 'txt-info' : ' '}
      >
        <div className={blt === 'aprimoramento' ? 'bullet-ia' : ' '} />
        Aprimoramento
        <HelpBalloon
          id="curation"
          message="Análise e edite o resultado da classificação das intenções não entendidas pela IA."
        />
      </p>
    </div>
  );
}

export default IntelligenceCardInfo;
